import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'src/components/molecules/page-header';

import { VisitSettings } from '@/features/settings/components/organisms/default/visit-settings';
import { withPermissions } from '@/permissions/can';

const DefaultSettings = () => {
  const { t } = useTranslation(['settings']);

  return (
    <>
      <PageHeader title={t('settings:default.title')} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          gap: 2,
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}>
          <VisitSettings />
        </Box>
      </Box>
    </>
  );
};

export default withPermissions(
  permissions => permissions.cannot('read', 'DefaultSettings'),
  DefaultSettings,
);
